<!-- 底部 -->
<template>
    <div v-if="is_PC" class="footer">
        <div class="logo">
            <img :src="`${enterprisesInformation.BottomLogo}`" alt="" />
        </div>
        <div class="msgItem" v-for="(item, idx) in msgInfo" :key="idx">
            <div class="tlt">{{ item.title }}</div>
            <div class="project" v-if="item.key != 'qr_code'">
                <span v-for="(it, x) in item.list" :key="x" @click.stop="toDetail(item, it)"
                    :class="{ 'high': item.key !== 'we_list', 'it': true }">
                    {{ item.val ? it[item.val] : it.SolutionOutline }}
                </span>
            </div>
            <div class="project" v-else>
                <img :src="enterprisesInformation.EnterprisesCode" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'UbertekWebsiteVueFooter',

    data() {
        return {
            msgInfo: [
                { title: '产品中心', key: 'solution', list: [] },
                { title: '新闻中心', key: 'cooperate', val: 'NewsName', list: [] },
                { title: '关于我们', key: 'about_us', list: [], val: 'detail' },
                { title: '联系我们', key: 'we_list', list: [] },
                { title: '关注我们', key: 'qr_code', list: [] }
            ]
        }
    },

    mounted() {
        this.getEnterprisesInfotmation()

        //解决问题/合作客户
        this.getSolution()
        this.getClient()

        //联系我们
        this.getContarctUs()
    },

    computed: {
        //学校信息
        enterprisesInformation() {
            if (this.$store.getters.get_enterprisesInformation) {
                return this.$store.getters.get_enterprisesInformation
            } else {
                return JSON.parse(localStorage.getItem('Enterprises'))
            }
        },
        ...mapState({
            is_PC: state => state.is_PC
        })
    },

    methods: {
        //获取企业联系方式资料
        getEnterprisesInfotmation() {
            let params = ''
            this.$store
                .dispatch('get_enterprises_information', params)
                .then(response => {
                    let res = response
                    if (res.statusText === 'OK' || res.status === 200) {
                        //所有公司信息
                        this.$store.commit('update_allEnterprisesInformation', res.data)
                        let showInfo = res.data.filter(i => i.ShowConnect)
                        //最少有一个
                        this.enterprisesData = showInfo[0]
                        //更新后的资料存到localStorage缓存区
                        localStorage.setItem('Enterprises', JSON.stringify(showInfo[0]))
                        //同时更新后的资料存到Vuex
                        this.$store.commit('update_enterprisesInformation', showInfo[0])
                        this.getBottomInfo()
                    } else {
                        this.$message.error(res.detail)
                    }
                })
                .catch(err => {
                    console.error(err)
                    // this.$message.error("您当前网络有问题，请稍后再试。");
                })
        },

        //获取底部信息栏
        getBottomInfo() {
            this.$store
                .dispatch('get_footerInfo', '')
                .then(response => {
                    let res = response
                    if (res.statusText === 'OK' || res.status === 200) {
                        let weList = []
                        weList.push(
                            {
                                SolutionOutline: `电话: ${this.enterprisesData.EnterprisesPhone}`
                            },
                            {
                                SolutionOutline: `邮箱: ${this.enterprisesData.EnterprisesEmail}`
                            },
                            {
                                SolutionOutline: `地址: ${this.enterprisesData.EnterprisesAddress}`
                            }
                        )
                        res.data.we_list = JSON.parse(JSON.stringify(weList))
                        this.msgInfo.forEach(it => {
                            for (let key in res.data) {
                                if (key == it.key) {
                                    //最多展示6条
                                    it.list =
                                        res.data[key].length <= 6
                                            ? res.data[key]
                                            : res.data[key].slice(0, 6)
                                }
                            }
                        })
                        return
                    }
                    this.$message.error(res.detail)
                })
                .catch(err => {
                    console.error(err)
                    // this.$message.error("您当前网络有问题，请稍后再试。");
                })
        },

        //获取解决问题及合作客户
        getSolution() {
            this.$store
                .dispatch('get_solutionList', '')
                .then(response => {
                    let res = response
                    if (res.statusText === 'OK' || res.status === 200) {
                        this.$store.commit(
                            'updateSolution',
                            JSON.parse(JSON.stringify(res.data))
                        )
                        return
                    }
                    this.$message.error(res.detail)
                })
                .catch(err => {
                    console.error(err)
                    // this.$message.error("您当前网络有问题，请稍后再试。");
                })
        },

        //获取解决问题及合作客户
        getClient() {
            this.$store
                .dispatch('get_cooperative', '')
                .then(response => {
                    let res = response
                    if (res.statusText === 'OK' || res.status === 200) {
                        this.$store.commit(
                            'updateCooprative',
                            JSON.parse(JSON.stringify(res.data))
                        )
                        return
                    }
                    this.$message.error(res.detail)
                })
                .catch(err => {
                    console.error(err)
                    // this.$message.error("您当前网络有问题，请稍后再试。");
                })
        },

        //获取联系我们页面数据
        getContarctUs() {
            this.$store
                .dispatch('get_contarctUsInfo', '')
                .then(response => {
                    let res = response
                    if (res.statusText === 'OK' || res.status === 200) {
                        this.$store.commit('updateContractUsInfo', res.data)
                        return
                    }
                    this.$message.error(res.detail)
                })
                .catch(err => {
                    console.error(err)
                    // this.$message.error("您当前网络有问题，请稍后再试。");
                })
        },

        //查看详情
        toDetail(row, it) {
            // console.log(row, it)
            //产品中心
            if (row.key == 'solution') {
                this.$router.push({
                    path: '/course',
                    query: {
                        key: it.SolutionOutline
                    }
                })
                if (this.$route.path === '/course') {
                    this.$store.commit('updateIsUpateProductScrollTop', true)
                }
                return
            }

            //新闻中心
            if (row.key == 'cooperate') {
                this.$router.push({
                    path: `/newsDetail/${it.id}`
                })
                if (this.$route.path.indexOf('/newsDetail') !== -1) {
                    this.$store.commit('updateMsgInfo', true)
                }
                return
            }

            //关于我们
            if (row.key == 'about_us') {
                this.$router.push({
                    path: '/contactUs',
                    query: {
                        key: it.detail
                    }
                })
                if (this.$route.path === '/contactUs') {
                    this.$store.commit('updateIsUpateProductScrollTop', true)
                }
                return
            }
        }
    }
}
</script>

<style scoped>
.footer {
    position: relative;
    width: 100%;
    height: 300px;
    background: url('@/assets/img/footer-bg.png') no-repeat center/cover;
    padding: 29px 120px;
    display: flex;
    justify-content: space-between;
}

.footer .logo img {
    width: 75px;
    height: 75px;
}

.footer .msgItem {
    color: #fff;
}

.footer .msgItem .tlt {
    font-family: PingFang SC;
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0px;
    color: #ffffff;
    margin-bottom: 30px;
}

.footer .msgItem .project {
    display: flex;
    flex-direction: column;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 17px;
    letter-spacing: 0px;
    color: #cccccc;
}

.footer .msgItem .project .it {
    margin-bottom: 16px;
}

.footer .msgItem .project .high:hover {
    color: #fff;
    cursor: pointer;
}

.footer .recordNumber {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    color: #fff
}
</style>
